import t from 'common/i18n';
import { UPLOAD_SOURCES } from '@cld/upload-widget-common';
import { asAbsolute } from 'root/routes/utils';

let items;

export default () => {
  if (!items) {
    items = [
      {
        path: asAbsolute(UPLOAD_SOURCES.DROPBOX),
        title: t('dropbox.menu.browse'),
      },
      {
        path: asAbsolute(UPLOAD_SOURCES.DROPBOX, 'recent'),
        title: t('dropbox.menu.recent'),
      },
    ];
  }

  return items;
};
